import axios from 'axios';

export default {
  view: async (site_id, filters, cancel_token) => {
    const response = await axios.get(
      `${site_id}/charts/view/`,
      {
        params: filters.as_query(),
        cancelToken: (cancel_token || {}).token,
      }
    );
    return response.data;
  },
};
